import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from '@/context/LanguageContext';
import { useEffect } from 'react';
import Home from '@/pages/Home';
import Services from '@/pages/Services';
import ServiceDetail from '@/pages/ServiceDetail';
import Booking from '@/pages/Booking';
import Blog from '@/pages/Blog';
import BlogPost from '@/pages/BlogPost';
import Contact from '@/pages/Contact';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import DashboardBookings from '@/pages/DashboardBookings';
import DashboardServices from '@/pages/DashboardServices';
import DashboardCampaigns from '@/pages/DashboardCampaigns';
import DashboardBlog from '@/pages/DashboardBlog';
import DashboardAnalytics from '@/pages/DashboardAnalytics';
import DashboardSiteSettings from '@/pages/DashboardSiteSettings';
import DashboardMessages from '@/pages/DashboardMessages';
import DashboardCopilot from '@/pages/DashboardCopilot';
import DashboardEvents from '@/pages/DashboardEvents';
import DashboardConsigli from '@/pages/DashboardConsigli';
import DashboardInstagram from '@/pages/DashboardInstagram';
import Events from '@/pages/Events';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import CookiePolicy from '@/pages/CookiePolicy';
import AIAssistant from '@/components/AIAssistant';
import CookieBanner from '@/components/CookieBanner';
import { Toaster } from '@/components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
}

function App() {
  useEffect(() => {
    if ('serviceWorker' in navigator && 'PushManager' in window && VAPID_PUBLIC_KEY) {
      navigator.serviceWorker.register('/sw.js').then(async (registration) => {
        try {
          const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
          });
          await fetch(`${BACKEND_URL}/api/push/subscribe`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ subscription: subscription.toJSON() })
          });
        } catch (e) { /* Push permission denied or not supported */ }
      }).catch(() => {});
    }
  }, []);

  return (
    <HelmetProvider>
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/servizi" element={<Services />} />
            <Route path="/servizi/:id" element={<ServiceDetail />} />
            <Route path="/prenota" element={<Booking />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/contatti" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/bookings" element={<DashboardBookings />} />
            <Route path="/dashboard/services" element={<DashboardServices />} />
            <Route path="/dashboard/campaigns" element={<DashboardCampaigns />} />
            <Route path="/dashboard/blog" element={<DashboardBlog />} />
            <Route path="/dashboard/analytics" element={<DashboardAnalytics />} />
            <Route path="/dashboard/site-settings" element={<DashboardSiteSettings />} />
            <Route path="/dashboard/messages" element={<DashboardMessages />} />
          <Route path="/dashboard/copilot" element={<DashboardCopilot />} />
            <Route path="/dashboard/events" element={<DashboardEvents />} />
            <Route path="/dashboard/consigli" element={<DashboardConsigli />} />
            <Route path="/dashboard/instagram" element={<DashboardInstagram />} />
            <Route path="/eventi" element={<Events />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
          </Routes>
          <AIAssistant />
          <CookieBanner />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
